<template>
  <div>
    <v-notification>
    </v-notification>
    <div class="activation-history__title">
      <img src="/img/svg/common/document-check.svg" alt=""/>
      <h1>{{ getLocalization('Activations history') }}</h1>
    </div>
    <div class="activation-history-partner">
      <base-table
          :columns="this.columns"
          :info-text="infoText"
          table-class="vgt-table --pc new-design-table"
          :render-list-to-show="this.listToShow"
          :wrapperFiltersData="this.wrapperFiltersData"
          :use-green-pagination="true"
          :dynamic-sort="true"
          :per-page-default="perPage"
          :table-title="null"
          :accept-filters-button-label="getLocalization('Apply filters')"
          :download-csv-text="getLocalization('Download CSV')"
          :enable-save-csv="true"
          csv-filename="phoneActivationList"
          save-csv-url="/cabinet/partner/activations/downloadcsv"
          new-design-class="activation-history-partner__body"
      >
        <template v-slot:base-table-row="props">
          <td v-if="props.column.field === 'service'">
            <div class="d-flex align-items-center gap-2">
              <img :src="props.row['service_img_path']" class="--image" alt=""/>
              <span>{{ props.row['service'] }}</span>
            </div>
          </td>
          <td v-else-if="props.column.field === 'country'">
            <div class="d-flex align-items-center gap-2">
              <img :src="props.row['country_img_path']" class="--image" alt=""/>
              <span>{{ getLocalization(props.row['country']) }}</span>
            </div>
          </td>
          <td v-else-if="props.column.field === 'status'">
            <div v-if="props.row['status_id'] === 6" class="d-flex align-items-center gap-2">
              <img src="/img/svg/common/round-check.svg" class="--icon" alt=""/>
              <span>{{getLocalization('Successfully')}}</span>
            </div>
            <div v-else class="d-flex align-items-center gap-2">
              <img src="/img/svg/common/round-error.svg" class="--icon" alt=""/>
              <span>{{getLocalization(props.row['status'])}}</span>
            </div>
          </td>
          <template v-else>
            <td>{{ props.formattedRow[props.column.field] }}</td>
          </template>
        </template>
        <template v-slot:base-table-pagination-green="props">
          <div class="sim-card-modal__pagination">
            <green-custom-pagination
                :total="props.totalCustom"
                :perPage="perPage"
                :pageChanged="props.pageChanged"

            ></green-custom-pagination>
          </div>
        </template>
      </base-table>
      <div v-if="filteredList.length > 0" class="activation-history-partner__body">
        <div class="--mobile">
          <div v-for="row in filteredList" class="activation-history-all-card">
            <div class="--item --row --flex-1">
              <div class="--label">{{ getLocalization('Date') }}</div>
              <div class="--value">{{ row['created_at'] }}</div>
            </div>
            <div class="--divider"></div>
            <div class="--item">
              <div class="--label">{{ getLocalization('Country') }}</div>
              <div class="--value">
                <div class="d-flex align-items-center gap-1">
                  <img :src="row['country_img_path']" class="--image" alt=""/>
                  <span>{{ row['country'] }}</span>
                </div>
              </div>
            </div>
            <div class="--item">
              <div class="--label">{{ getLocalization('Service') }}</div>
              <div class="--value">
                <div class="d-flex align-items-center gap-1">
                  <img :src="row['service_img_path']" class="--image" alt=""/>
                  <span>{{ row['service'] }}</span>
                </div>
              </div>
            </div>
            <div class="--divider"></div>
            <div class="--item">
              <div class="--label">{{ getLocalization('Status') }}</div>
              <div v-if="row['status_id'] === 6" class="--value">
                <div class="d-flex align-items-center gap-1">
                  <img src="/img/svg/common/round-check.svg" class="--icon" alt=""/>
                  <span>{{getLocalization('Successfully')}}</span>
                </div>
              </div>
              <div v-else class="--value">
                <div class="d-flex align-items-center gap-1">
                  <img src="/img/svg/common/round-error.svg" class="--icon" alt=""/>
                  <span>{{getLocalization('Canceled')}}</span>
                </div>
              </div>
            </div>
            <div class="--item">
              <div class="--label">{{ getLocalization('Phone number') }}</div>
              <div class="--value">{{ row['phone'] }}</div>
            </div>
            <div class="--item">
              <div class="--label">{{ getLocalization('Price') }}</div>
              <div class="--value">{{ row['reward'] }} ₽</div>
            </div>
            <div class="--divider"></div>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>
<script>
import BaseAdminMixin from "../../../../admin/components/mixins/BaseAdminMixin.vue";
import WrapperFiltersComponent from "../../../../components/table/wrapperFilters.vue";
import GreenCustomPagination from "../../../../components/table/pagination/greenCustomPagination.vue";
import CustomPagination from "../../../../components/table/pagination/customPagination.vue";
import BaseTable from "../../../../components/table/baseTable.vue";

export default {
  name: "simCardsStatisticTable",
  mixins: [
    BaseAdminMixin
  ],
  components: {
    BaseTable,
    CustomPagination,
    WrapperFiltersComponent,
    GreenCustomPagination
  },
  props: [
    'defaultDateFrom'
  ],
  data: function () {
    return {
      filteredList: [],
      wrapperFiltersData: {
        title: this.getLocalization('Activations history'),
        startWithRequest: true,
        filtersUrl: "/cabinet/partner/activations/getList",
        showResetFilterButton: true,
        sendFilterRequestAfterSelect: false,
        showCollapseFilter: true,
        wrapperLoadColor: '#209E73',
        newDesign: true,
        items: {
          countries: {
            enable: true,
            multiple: true,
            getDataLink: '/countries/getList',
            placeholder: this.getLocalization('Countries'),
            viewLabel: 'title',
            className: '--6-12',
            needLocalization: true
          },
          services: {
            enable: true,
            multiple: true,
            getDataLink: '/services/getList',
            placeholder: this.getLocalization('Services'),
            viewLabel: 'title',
            className: '--6-12'
          },
          statuses: {
            enable: true,
            multiple: true,
            selectedKey: 'statuses',
            getDataLink: '/cabinet/client/phonehistory/getPhoneActivationStatuses',
            placeholder: this.getLocalization('Status'),
            specifyKeyForLabel: 'description',
            className: 'w-100',
            needLocalization: true,
            // defaultValue: [{
            //   id: 6,
            //   title: this.getLocalization('Service has been activated')
            // }],
            // setDefaultInFilters: [
            //   6
            // ]
          },
          date: {
            enable: true,
            dateFromText: this.getLocalization('Date from'),
            dateToText: this.getLocalization('Date to'),
            className: 'w-100',
            circle: true
          },
        },
      },
      infoText: '',
      perPage: 50,
      columns: [
        {
          label: 'ID',
          field: 'id',
          sortable: false,
        },
        {
          label: this.getLocalization('Date'),
          field: 'created_at',
          sortable: true,
          sortByColumn: 'created_at',
        },

        {
          label: this.getLocalization('Service'),
          sortable: false,
          field: 'service',
        },

        {
          label: this.getLocalization('Country'),
          field: 'country',
          sortable: false,
        },
        {
          label: this.getLocalization('Reward'),
          sortable: true,
          sortByColumn: 'wholesale_price',
          field: 'reward',
          sortFn: 'sortNumber',
        },
        {
          label: this.getLocalization('Status'),
          field: 'status',
          type: 'string',
          sortByColumn: 'status',
          sortable: true,
        },
        {
          label: this.getLocalization('Phone'),
          field: 'phone',
          sortable: false,
        },
      ],
    };
  },
  methods: {
    listToShow: function (phoneActivations) {
      let data = [];
      let phoneActivationsData = phoneActivations['data'];
      let rewards = 0;
      for (let elem in phoneActivationsData) {
        rewards += parseInt(phoneActivationsData[elem]['wholesale_price']);
        data.push({
          country_img_path: phoneActivationsData[elem]['service_variation']['country']['img_path'],
          country: phoneActivationsData[elem]['service_variation']['country']['title'],
          service_img_path: phoneActivationsData[elem]['service_variation']['service']['img_path'],
          service: phoneActivationsData[elem]['service_variation']['service']['title'],
          phone: phoneActivationsData[elem]['phone'],
          reward: phoneActivationsData[elem]['wholesale_price'],
          created_at: phoneActivationsData[elem]['created_at'],
          status: phoneActivationsData[elem]['status']['description'],
          status_id: phoneActivationsData[elem]['status']['id'],
          id: phoneActivationsData[elem]['id'],
        });
      }
      this.setFilteredList(data);
      this.getInfoText(phoneActivations);
      return data;
    },
    setFilteredList(response) {
      this.filteredList = [];
      this.filteredList = response;
      this.getInfoText(response);
    },
    getInfoText(response) {
      let sum = 0;
      let total = 0;
      if (response?.total_sum?.sum) {
        sum = response.total_sum.sum;
      }
      if (response.total) {
        total = response.total;
      }
      this.infoText = this.getLocalization('Total') + ': ' + total
          + this.getLocalization('rows') + ' ' + this.getLocalization('and') + ' ' + sum + ' '
          + this.getLocalization('rubles of reward');
    }
  },
}
</script>
<style>
.multiselect__tags-wrap {
  max-height: 36px;
  overflow: auto;
}
</style>
